var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04167 0.895833V2.35833C6.04167 3.26842 6.04167 3.72346 6.21878 4.07107C6.37458 4.37683 6.62317 4.62542 6.92893 4.78122C7.27654 4.95833 7.73158 4.95833 8.64167 4.95833H10.1042M10.375 6.03529V7.775C10.375 8.68509 10.375 9.14013 10.1979 9.48773C10.0421 9.7935 9.7935 10.0421 9.48773 10.1979C9.14013 10.375 8.68509 10.375 7.775 10.375H3.225C2.31491 10.375 1.85987 10.375 1.51227 10.1979C1.2065 10.0421 0.957909 9.7935 0.802114 9.48773C0.625 9.14013 0.625 8.68509 0.625 7.775V3.225C0.625 2.31491 0.625 1.85987 0.802114 1.51227C0.957909 1.2065 1.2065 0.957909 1.51227 0.802114C1.85987 0.625 2.31491 0.625 3.225 0.625H4.96471C5.36217 0.625 5.5609 0.625 5.74792 0.669899C5.91373 0.709706 6.07224 0.775363 6.21763 0.86446C6.38162 0.964953 6.52214 1.10548 6.80319 1.38652L9.61348 4.19681C9.89452 4.47786 10.035 4.61838 10.1355 4.78237C10.2246 4.92776 10.2903 5.08627 10.3301 5.25208C10.375 5.4391 10.375 5.63783 10.375 6.03529Z",
    stroke: "#1D242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageIcon);
export default __webpack_public_path__ + "static/media/page-icon.45d6e906fdddc8276d216118ee2e8625.svg";
export { ForwardRef as ReactComponent };